import { useIsThemeLoading, useThemeFlags } from "src/hooks";

import { useLiveChat } from "./hooks";

/**
 * Mounts the live chat widget unless the client's theme file disables it.
 *
 * Lives inside ThemeWrapper (and therefore inside the redux Provider) so it can
 * read the theme flags. Injection is held back while a custom theme is still
 * loading, otherwise the widget would flash in before a `disableChat` theme
 * resolves.
 */
const LiveChat = () => {
  const flags = useThemeFlags();
  const isThemeLoading = useIsThemeLoading();

  useLiveChat(!flags.disableChat && !isThemeLoading);

  return null;
};

export default LiveChat;
